function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#000000",
    d: "M 117.5,45.5 C 209.501,45.3333 301.501,45.5 393.5,46C 439.245,54.0775 468.078,80.5775 480,125.5C 480.93,130.799 481.597,136.133 482,141.5C 482.957,197.187 482.624,252.854 481,308.5C 470.479,358.354 439.979,386.854 389.5,394C 365.833,394.333 342.167,394.667 318.5,395C 317.167,395.667 315.833,396.333 314.5,397C 297.549,419.619 280.216,441.953 262.5,464C 256.143,466.549 250.31,465.716 245,461.5C 228.415,438.804 211.249,416.637 193.5,395C 166.808,394.915 140.141,394.249 113.5,393C 67.2125,383.046 39.3791,354.879 30,308.5C 28.8758,279.022 28.3758,249.522 28.5,220C 28.6667,193.833 28.8333,167.667 29,141.5C 32.2585,100.933 52.0918,71.7659 88.5,54C 97.9732,50.0535 107.64,47.2202 117.5,45.5 Z M 125.5,71.5 C 212.167,71.3333 298.834,71.5 385.5,72C 415.951,75.1375 437.451,90.6375 450,118.5C 452.609,124.934 454.275,131.601 455,138.5C 455.667,192.833 455.667,247.167 455,301.5C 449.373,335.591 429.873,357.091 396.5,366C 369.868,367.279 343.202,367.946 316.5,368C 307.025,369.153 299.192,373.32 293,380.5C 280.661,397 268.161,413.333 255.5,429.5C 242.839,413.333 230.339,397 218,380.5C 211.808,373.32 203.975,369.153 194.5,368C 167.798,367.946 141.132,367.279 114.5,366C 81.1256,357.085 61.6256,335.585 56,301.5C 55.3333,246.833 55.3333,192.167 56,137.5C 63.8362,99.1597 87.0029,77.1597 125.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.956
    },
    fill: "#000000",
    d: "M 162.5,192.5 C 188.436,194.022 197.936,207.355 191,232.5C 183.855,244.482 173.355,248.982 159.5,246C 145.28,240.778 138.78,230.612 140,215.5C 142.347,202.655 149.847,194.988 162.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.958
    },
    fill: "#000000",
    d: "M 250.5,192.5 C 272.837,192.335 283.337,203.335 282,225.5C 276.787,241.864 265.62,248.697 248.5,246C 229.64,238.097 224.14,224.597 232,205.5C 236.689,198.964 242.856,194.631 250.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#000000",
    d: "M 339.5,192.5 C 361.316,192.149 371.816,202.815 371,224.5C 366.336,241.591 355.17,248.758 337.5,246C 327.009,243.509 320.509,237.009 318,226.5C 315.362,208.745 322.528,197.412 339.5,192.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBot);
export default __webpack_public_path__ + "static/media/chat-bot.42e08523ebd4131be978908e59bc42e0.svg";
export { ForwardRef as ReactComponent };